---
ID: 66d77dda4a9fb5d976f7d516
---

<script>
    import Loader from "$lib/components/elements/Loader.svelte"

    const blocks = [
  {
    "id": "xkUsZjwARL",
    "type": "text",
    "html": "<p>EasyPageGO is a powerful no-code website builder that provides a true \"What You See Is What You Get\" (<b>WYSIWYG</b>) editing experience. Our intuitive editor allows you to create, customize, and preview your website’s content, layout, and components directly within the platform, ensuring an accurate representation of the final look and feel of your site.</p><h2 id=\"no-code-visual-editing\"><b>No-Code Visual Editing</b></h2><p>With EasyPageGO, enjoy a seamless no-code visual editing experience. Our editor mirrors the final design of your site, making it easy to see exactly how your changes will appear to visitors. This eliminates guesswork and simplifies the website creation process.</p><h2 id=\"autosave-functionality\"><b>Autosave Functionality</b></h2><p>The editor’s&nbsp;<b>autosave</b>&nbsp;feature continuously and automatically saves your changes in real-time. This ensures all your tweaks are instantly preserved, so you can focus on your work without worrying about manual saves.</p><h2 id=\"optimized-for-all-devices\"><b>Optimized for All Devices</b></h2><p>Ensure a consistent and appealing design across all devices with EasyPageGO's responsive design features. Switch between mobile, tablet, and desktop viewports to fine-tune your content and layout for every screen size.</p>"
  },
  {
    "type": "video",
    "id": "lqwc0LAA_D",
    "src": "https://easypagego.com/videos/dynamic-preview-970x720.mp4",
    "width": 600,
    "height": 450,
    "loop": true,
    "muted": true,
    "autoplay": true
  },
  {
    "id": "ekZPJ7_Tkf",
    "type": "text",
    "html": "<h2 id=\"flexible-block-based-structure\"><b>Flexible Block-Based Structure</b></h2><p>Our block-based editor allows you to organize content efficiently. Each piece of content is managed as an individual block, including&nbsp;<u><a href=\"https://docs.easypagego.com/editor/text-formatting/\" target=\"_blank\" rel=\"noopener noreferrer\">text</a></u>&nbsp;blocks,&nbsp;<u><a href=\"https://docs.easypagego.com/editor/accordions/\" target=\"_blank\" rel=\"noopener noreferrer\">accordions</a></u>,&nbsp;<u><a href=\"https://docs.easypagego.com/editor/codeblocks/\" target=\"_blank\" rel=\"noopener noreferrer\">code</a></u>&nbsp;blocks, and advanced elements like&nbsp;<u><a href=\"https://docs.easypagego.com/editor/mermaid-graphs/\" target=\"_blank\" rel=\"noopener noreferrer\">Mermaid graphs</a></u>. You can easily move, delete, or insert blocks using the convenient dropdown buttons that appear when a block is active or hovered over.</p>"
  },
  {
    "id": "2L7AsTpl0D",
    "type": "callout",
    "variant": "info",
    "html": "<p>Each block can be customized or rearranged directly in the editor for a flexible and dynamic website design.</p>"
  }
];
</script>

{#each blocks as block}
<Loader {block}/>
{/each}